<template>
  <Modal :open="open" size="big" @close="$emit('close')">
    <h2 class="text-lg font-semibold mb-4 text-center w-full">{{ t("title") }}</h2>

    <ClaimDecisionFlow v-if="open" :claim="claim" @done="$emit('close')" />
  </Modal>
</template>

<script>
import { useI18n } from "vue-i18n";
import { Modal } from "@estaly/ui";
import ClaimDecisionFlow from "@/components/claim/details/action/ClaimDecisionFlow.vue";

export default {
  name: "ClaimDecisionModal",

  components: { Modal, ClaimDecisionFlow },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  props: ["open", "claim"],
  emits: ["close"],
};
</script>

<i18n src="./ClaimDecisionModal.i18n.json"></i18n>
